import React from "react";

export const ConfirmSignUpFormChanged = React.createContext(null);
